export default {"src":"/_next/static/media/btn_close2_b.3053d271.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};